import {API_BASE_URL} from "./util/constants";
import axios from "axios";
import store from './store';

const instance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  }
});

instance.interceptors.request.use((config) => {
  store.dispatch('loader/startLoading');
  const authorization = JSON.parse(localStorage.getItem('authorization'));

  if (authorization) {
    config.headers['Authorization'] = `${authorization.tokenType} ${authorization.accessToken}`;
  }
  return config;
}, (error) => {
  store.dispatch('loader/stopLoading');
  return Promise.reject(error);
});

instance.interceptors.response.use((response) => {
  store.dispatch('loader/stopLoading');
  return response;
}, (error) => {
  store.dispatch('loader/stopLoading');
  if (error.response && error.response.status === 401) {
    store.dispatch("auth/logout");
    window.location.href = '/login'; 
  }
  return Promise.reject(error);
});

export default instance;